import { ReactElement } from 'react';
import { SubscriptionType } from '@sc/graphql';
import {
  PaperAirplaneIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';

// Each tier gets its own marker; the free/essentials paper plane is the base.
// Callers pass sizing/colour classes so the same mapping serves the large
// plan panel and compact table rows.
export const planIcon = (
  type: SubscriptionType | null,
  className: string
): ReactElement => {
  if (type === SubscriptionType.enterprise)
    return <RocketLaunchIcon className={className} />;

  return <PaperAirplaneIcon className={`${className} -rotate-90`} />;
};
